    <div class="mx-auto mb-8 animate-fade-in">
        <div class="flex flex-col md:flex-row md:items-end justify-between mb-4 gap-4">
            <div class="relative">
                <h2 class="text-3xl md:text-4xl font-extrabold text-gray-900 leading-tight">
                    <span class="bg-clip-text text-transparent bg-gradient-to-r from-indigo-600 to-violet-600">
                        Property Listings
                    </span>
                </h2>
                <p class="text-sm font-semibold text-gray-400 mt-1 uppercase tracking-wider">
                    Showing {{ filteredProperties.length }} of {{ meta?.total }} properties
                    <!-- Showing {{ filteredProperties.length }} of {{ totalProperty.total }} Total Listings -->
                </p>
                <div class="w-12 h-1.5 bg-indigo-500 rounded-full mt-3"></div>
            </div>
        </div>
    
        <div class="mb-4 p-4 bg-white rounded-2xl border border-gray-100 flex flex-col sm:flex-row gap-4 items-center shadow-sm hover:shadow-md transition-shadow duration-300">
            <div class="relative flex-grow w-full">
                <input 
                    type="text" 
                    placeholder="Search properties, locations, or builders..." 
                    [(ngModel)]="searchTerm"
                    (input)="onSearchChange()"
                    class="w-full py-3 pl-12 pr-4 bg-gray-50 border-transparent rounded-xl focus:ring-2 focus:ring-indigo-500 focus:bg-white transition-all duration-200 outline-none text-gray-700"
                />
                <svg class="absolute left-4 top-1/2 transform -translate-y-1/2 h-5 w-5 text-indigo-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
            </div>
            <button 
                type="button" 
                (click)="searchItem()"
                class="w-full sm:w-auto flex items-center text-nowrap border-1 justify-center px-8 py-3 text-sm font-bold rounded-xl text-indigo-600 border-indigo-600 bg-white hover:text-white hover:bg-indigo-700 transition-all shadow-sm shadow-indigo-200 active:scale-95">
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"/>
                </svg>
                Search
            </button>
            <button 
                type="button" 
                *ngIf="isRoteHasPermissions('canAddProperties')"
                routerLink="/admin/property/add"
                class="w-full sm:w-auto flex items-center text-nowrap justify-center px-8 py-3 text-sm font-bold rounded-xl text-white bg-indigo-600 hover:bg-indigo-700 transition-all shadow-lg shadow-indigo-200 active:scale-95">
                <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M12 4v16m8-8H4"/></svg>
                New Property
            </button>
            <button 
                type="button" 
                *ngIf="isRoteHasPermissions('canExportProperties')"
                (click)="exportPropertiesToExcel()"
                [disabled]="isExporting"
                class="w-full sm:w-auto flex items-center text-nowrap justify-center px-8 py-3 text-sm font-bold rounded-xl text-indigo-700 bg-indigo-50 hover:bg-indigo-100 border border-indigo-200 transition-all shadow-sm active:scale-95 disabled:opacity-60 disabled:cursor-not-allowed">
                <svg *ngIf="!isExporting" class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3"/>
                </svg>
                <svg *ngIf="isExporting" class="w-5 h-5 mr-2 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                </svg>
                {{ isExporting ? 'Exporting...' : 'Export Excel' }}
            </button>
        </div>
    
        <ng-container *ngIf="meta?.total > 0; else noPropertiesFound">
            
            <div class="grid grid-cols-1 gap-6 sm:hidden">
                <div *ngFor="let property of filteredProperties; let i = index" 
                    class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden"
                    [style.animationDelay.ms]="i * 50">
                    
                    <div class="h-44 bg-slate-100 relative flex items-center justify-center group">
                        <span [ngClass]="property.isSoldOut ? 'bg-rose-500' : 'bg-emerald-500'"
                              class="absolute top-4 left-4 text-[10px] font-black text-white px-3 py-1 rounded-lg shadow-sm tracking-widest uppercase">
                            {{ property.isSoldOut ? 'SOLD' : 'LIVE' }}
                        </span>
                        <button class="absolute top-4 right-4 p-2 bg-white/80 backdrop-blur rounded-full text-amber-500 shadow-sm" *ngIf="property.isLiked">
                            <svg class="w-5 h-5 fill-current" viewBox="0 0 20 20"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>
                        </button>
                        <span class="text-slate-400 font-bold text-sm tracking-tight uppercase opacity-50">No Preview Available</span>
                    </div>
    
                    <div class="p-5">
                        <div class="mb-4">
                            <h3 class="text-lg font-bold text-gray-900 mb-1">{{ property.name }}</h3>
                            <p class="text-2xl font-black text-indigo-600">{{ formatPriceDisplay(property.price) }}</p>
                        </div>
                        <div class="grid grid-cols-3 gap-2 py-3 border-y border-gray-50 mb-5">
                            <div class="text-center"><p class="text-[10px] text-gray-400 font-bold uppercase">Beds</p><p class="text-sm font-bold text-gray-700">{{ property.bedrooms }}</p></div>
                            <div class="text-center"><p class="text-[10px] text-gray-400 font-bold uppercase">Area</p><p class="text-sm font-bold text-gray-700">{{ property.landArea }}</p></div>
                            <div class="text-center"><p class="text-[10px] text-gray-400 font-bold uppercase">Type</p><p class="text-sm font-bold text-gray-700 truncate px-1">{{ property.propertyType }}</p></div>
                        </div>
                        <div class="flex gap-2">
                            <button (click)="viewDetails(property)" class="flex-1 py-3 bg-indigo-600 text-white rounded-xl font-bold text-sm shadow-md active:scale-95">View Details</button>
                            <button (click)="editProperty(property)" class="px-4 py-3 bg-amber-50 text-amber-600 rounded-xl border border-amber-100"><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" stroke-width="2"/></svg></button>
                        </div>
                    </div>
                </div>
            </div>
    
            <div class="hidden sm:block overflow-visible rounded-2xl border border-gray-100 bg-white shadow-sm">
                <table class="min-w-full divide-y divide-gray-100">
                    <thead class="bg-slate-50">
                        <tr>
                            <th class="px-6 py-4 text-left text-[11px] font-black text-slate-400 uppercase tracking-[0.15em]">Property / Builder</th>
                            <th class="px-6 py-4 text-left text-[11px] font-black text-slate-400 uppercase tracking-[0.15em]">Details</th>
                            <th class="px-6 py-4 text-right text-[11px] font-black text-slate-400 uppercase tracking-[0.15em]">Price</th>
                            <th class="px-6 py-4 text-center text-[11px] font-black text-slate-400 uppercase tracking-[0.15em]">Status</th>
                            <th class="px-6 py-4 text-center text-[11px] font-black text-slate-400 uppercase tracking-[0.15em]">
                                Last update
                                <span class="ml-1" (click)="sortByUpdatedAt()">
                                    <svg *ngIf="sortDirection === 'desc'" class="w-3 h-3 inline" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M5 8l5 5 5-5H5z"/>
                                    </svg>

                                    <svg *ngIf="sortDirection === 'asc'" class="w-3 h-3 inline" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M5 12l5-5 5 5H5z"/>
                                    </svg>
                                </span>
                            </th>
                            <th class="px-6 py-4 text-center text-[11px] font-black text-slate-400 uppercase tracking-[0.15em]">Updated By</th>
                            <th class="px-6 py-4 text-right text-[11px] font-black text-slate-400 uppercase tracking-[0.15em]">Actions</th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-50">
                        <tr *ngFor="let property of filteredProperties; let i = index" class="hover:bg-indigo-50/40 transition-all group">
                            <td class="px-6 py-5 whitespace-nowrap">
                                <div class="flex flex-col cursor-pointer" (click)="viewDetails(property)">
                                    <span class="text-sm font-extrabold text-gray-900 group-hover:text-indigo-600 transition-colors">{{ property.name }}</span>
                                    <span class="text-xs text-gray-400 flex items-center mt-1">
                                        <svg class="w-3.5 h-3.5 mr-1 text-rose-400" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd"/></svg>
                                        {{ property.microMarket?.micromarketName }}&nbsp;
                                        <span *ngIf="cleanCluster(property.microMarket?.cluster)">
                                            ({{ cleanCluster(property.microMarket?.cluster) }})
                                        </span>
                                    </span>
                                </div>
                            </td>
                            <td class="px-6 py-5 whitespace-nowrap">
                                <div class="flex flex-col">
                                    <div>
                                        <span class="text-[10px] font-black uppercase " *ngFor="let price of getPrices(property); let i = index; let last = last">
                                            {{ price.bhkType }}<span *ngIf="!last">, </span>
                                        </span>
                                        <span class="text-[10px] font-black text-indigo-500 uppercase px-2 ms-2 py-0.5 bg-indigo-50 rounded w-fit mb-1">
                                            {{ property.propertyType }}
                                        </span>
                                    </div>
                                    <span class="text-xs font-bold text-gray-600">
                                        Land Area - {{ property.superBuiltUpArea | numberFormat }} Sq Ft
                                        <!-- {{ property | json}} -->
                                    </span>
                                </div>
                            </td>
                            <td class="px-6 py-5 text-right">
                                <span class="text-sm font-black text-gray-900">{{ formatPriceDisplay(property.price) }}</span>
                            </td>
                            <td class="px-6 py-5 text-center">
                                <span [ngClass]="property.isSoldOut ? 'text-rose-600 bg-rose-50 border-rose-100' : 'text-emerald-600 bg-emerald-50 border-emerald-100'"
                                      class="px-3 py-1 text-[10px] font-black rounded-full border uppercase tracking-tighter">
                                    {{ property.isSoldOut ? 'Sold' : 'Active' }}
                                      <!-- {{ filteredProperties[0] | json }} -->
                                </span>
                            </td>
                            <td class="px-6 py-5 text-center">
                                <span class="text-sm font-black text-gray-900">
                                    {{ property.updatedAt | date:'dd MMM yyyy' }}
                                </span>
                            </td>
                            <td class="px-6 py-5 text-center">
                                <span class="text-sm font-black text-gray-900">
                                   {{formateUser(property?.propUpdatedBy)}}
                                </span>
                            </td>
                            <td class="px-6 py-5 text-right">
                                <div class="relative action-dropdown inline-block text-left">

                                    <!-- Trigger Button -->
                                    <button
                                        (click)="toggleDropdown(property._id)"
                                        class="p-2 rounded-lg hover:bg-gray-100 text-gray-600">
                                        
                                        <svg class="w-5 h-5 text-gray-900" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-width="3" stroke-linecap="round" stroke-linejoin="round"
                                                    d="M12 5h.01M12 12h.01M12 19h.01" />
                                        </svg>
                                    </button>

                                    <!-- Dropdown -->
                                    <div
                                        *ngIf="activeDropdown === property._id"
                                        class="absolute right-0 mt-2 w-44 bg-white border border-gray-200 rounded-xl shadow-lg z-50">

                                        <button 
                                        (click)="viewDetails(property)"
                                        class="flex items-center w-full px-4 py-2 text-sm hover:bg-gray-50">
                                        👁 View Details
                                        </button>

                                        <button *ngIf="isRoteHasPermissions('canAddProperties')"
                                        (click)="showGallery(property)"
                                        class="flex items-center w-full px-4 py-2 text-sm hover:bg-gray-50">
                                        🖼 Edit Gallery
                                        </button>

                                        <button *ngIf="isRoteHasPermissions('canAddProperties')"
                                        (click)="editProperty(property)"
                                        class="flex items-center w-full px-4 py-2 text-sm hover:bg-gray-50">
                                        ✏ Edit Property
                                        </button>

                                        <button *ngIf="isRoteHasPermissions('canDeleteProperties')"
                                        (click)="openDeleteModal(property._id)"
                                        class="flex items-center w-full px-4 py-2 text-sm text-red-600 hover:bg-red-50">
                                        🗑 Delete Property
                                        </button>

                                    </div>

                                    </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div *ngIf="totalPages > 1" class="flex items-center justify-between mt-6 px-4 py-4 bg-white border border-gray-100 rounded-2xl shadow-sm">

                <div class="text-sm text-gray-500 font-semibold">
                    Page {{ currentPage }} of {{ totalPages }}
                </div>

                <div class="flex items-center gap-2">

                    <!-- Previous -->
                    <button
                        (click)="getAllProperties(currentPage - 1)"
                        [disabled]="currentPage === 1"
                        class="px-3 py-1 border rounded-sm boder-grey-300 hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                        Previous
                    </button>

                    <!-- First page -->
                    <button
                        *ngIf="currentPage > 3"
                        (click)="getAllProperties(1)"
                        class="px-3 py-1 border rounded-sm boder-grey-300 hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                        1
                    </button>

                    <span *ngIf="currentPage > 4">...</span>

                    <!-- Visible pages -->
                    <button
                        *ngFor="let page of getVisiblePages()"
                        (click)="getAllProperties(page)"
                        [class.bg-blue-600]="page === currentPage"
                        [class.text-white]="page === currentPage"
                        class="px-3 py-1 border rounded-sm boder-grey-300 hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                        {{ page }}
                    </button>

                    <span *ngIf="currentPage < totalPages - 3">...</span>

                    <!-- Last page -->
                    <button
                        *ngIf="currentPage < totalPages - 2"
                        (click)="getAllProperties(totalPages)"
                        class="px-3 py-1 border rounded-sm boder-grey-300 hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                        {{ totalPages }}
                    </button>

                    <!-- Next -->
                    <button
                        (click)="getAllProperties(currentPage + 1)"
                        [disabled]="currentPage === totalPages"
                        class="px-3 py-1 border rounded-sm boder-grey-300 hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                        Next
                    </button>

                    </div>
            </div>

        </ng-container>
    
        <ng-template #noPropertiesFound>
            <div class="text-center py-20 bg-white rounded-3xl border border-gray-100 shadow-sm">
                <div class="inline-flex items-center justify-center w-20 h-20 bg-indigo-50 text-indigo-300 rounded-full mb-6">
                    <svg class="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2m-7 7h-2" /></svg>
                </div>
                <h3 class="text-xl font-black text-gray-900 mb-2">Nothing found</h3>
                <p class="text-gray-400 max-w-xs mx-auto text-sm font-medium">No results match your current search criteria. Try a different keyword.</p>
                <button (click)="searchTerm = ''; onSearchChange()" class="mt-6 text-indigo-600 font-bold hover:underline">Clear search</button>
            </div>
        </ng-template>
    </div>


    @if (isImageModalOpen) {
        <div class="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6 backdrop-blur-sm bg-gray-900/60 animate-in fade-in duration-300" [class.modal-enter]="!isClosing"
        [class.modal-exit]="isClosing">
            <div class="bg-white w-full max-w-4xl max-h-[90vh] rounded-3xl shadow-2xl overflow-hidden flex flex-col animate-in zoom-in-95 slide-in-from-bottom-4 duration-300" [class.modal-content-enter]="!isClosing"
            [class.modal-content-exit]="isClosing">
                
                <div class="px-6 pt-6 pb-2 flex items-center justify-between bg-white">
                    <div>
                        <h3 class="text-xl font-black text-gray-900">{{selectedPro?.name}}</h3>
                        <p class="text-[10px] font-bold text-indigo-500 uppercase tracking-widest">Media Assets Management</p>
                    </div>
                    <button (click)="closeModal()" class="p-2 hover:bg-gray-100 rounded-full transition-colors text-gray-400 hover:text-gray-900">
                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
                    </button>
                </div>
        
                <div class="px-6 border-b border-gray-100">
                    <div class="flex gap-8">
                        <button (click)="activeTab = 'gallery'" 
                            [class]="activeTab === 'gallery' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-400 hover:text-gray-600'"
                            class="pb-4 border-b-2 font-bold text-xs uppercase tracking-widest transition-all flex items-center gap-2">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" stroke-width="2"/></svg>
                            Gallery
                        </button>
                        <button (click)="activeTab = 'plans'" 
                            [class]="activeTab === 'plans' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-400 hover:text-gray-600'"
                            class="pb-4 border-b-2 font-bold text-xs uppercase tracking-widest transition-all flex items-center gap-2">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M9 20l-5.447-2.724A2 2 0 013 15.488V5.512a2 2 0 011.553-1.944L9 2m6 18l5.447-2.724A2 2 0 0021 15.488V5.512a2 2 0 00-1.553-1.944L15 2m-6 18V2m6 18V2" stroke-width="2"/></svg>
                            Floor Plans
                        </button>
                        <button (click)="activeTab = 'video'" 
                            [class]="activeTab === 'video' ? 'border-indigo-600 text-indigo-600' : 'border-transparent text-gray-400 hover:text-gray-600'"
                            class="pb-4 border-b-2 font-bold text-xs uppercase tracking-widest transition-all flex items-center gap-2">
                            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" stroke-width="2"/></svg>
                            Videos
                        </button>
                    </div>
                </div>
        
                <div class="flex-grow overflow-y-auto p-6 bg-gray-50/50">
                    
                    @if (activeTab === 'gallery') {
                        @if (selectedPro?.galleryImage?.length > 0) {
                            <div class="grid grid-cols-2 md:grid-cols-3 gap-4 animate-in fade-in slide-in-from-bottom-2">
                                @for (img of selectedPro?.galleryImage; track img; let i = $index) {
                                    <div class="group relative aspect-square rounded-2xl overflow-hidden bg-gray-200 shadow-sm hover:shadow-xl transition-all duration-500">
                                        <img [src]="img" class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110">
                                        
                                        <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            
                                            <div class="absolute top-2 right-2">
                                                <button 
                                                    (click)="$event.stopPropagation(); onDeleteImage(selectedPro?._id, img, 'gallery')"
                                                    class="p-2 bg-red-500 hover:bg-red-600 text-white rounded-full shadow-lg transform translate-y-2 group-hover:translate-y-0 transition-all duration-300"
                                                    title="Delete Image">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                    </svg>
                                                </button>
                                            </div>
                                
                                            <div class="absolute bottom-0 left-0 right-0 p-3">
                                                <span class="text-white text-[10px] font-bold uppercase tracking-wider block truncate">
                                                    {{ selectedPro?.name }} Img {{i+1}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        } @else {
                            <div class="flex flex-col items-center justify-center py-20 text-gray-400">
                                <svg class="w-12 h-12 mb-2 opacity-20" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" stroke-width="2"/></svg>
                                <p class="font-bold">No gallery images</p>
                            </div>
                        }
                    }
        
                    @if (activeTab === 'plans') {
                        @if (selectedPro?.planImage?.length > 0) {
                            <div class="grid grid-cols-2 md:grid-cols-3 gap-4 animate-in fade-in slide-in-from-bottom-2">
                                @for (img of selectedPro?.planImage; track img; let i = $index) {
                                    <div class="group relative aspect-square rounded-2xl overflow-hidden bg-gray-200 shadow-sm hover:shadow-xl transition-all duration-500">
                                        <img [src]="img" class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110">
                                        
                                        <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            
                                            <div class="absolute top-2 right-2">
                                                <button 
                                                    (click)="$event.stopPropagation(); onDeleteImage(selectedPro?._id, img, 'plan')"
                                                    class="p-2 bg-red-500 hover:bg-red-600 text-white rounded-full shadow-lg transform translate-y-2 group-hover:translate-y-0 transition-all duration-300"
                                                    title="Delete Image">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                    </svg>
                                                </button>
                                            </div>
                                
                                            <div class="absolute bottom-0 left-0 right-0 p-3">
                                                <span class="text-white text-[10px] font-bold uppercase tracking-wider block truncate">
                                                    {{ selectedPro?.name }} Img {{i+1}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        } @else {
                            <div class="flex flex-col items-center justify-center py-20 text-gray-400 animate-in fade-in">
                                <svg class="w-12 h-12 mb-2 opacity-20" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M9 20l-5.447-2.724A2 2 0 013 15.488V5.512a2 2 0 011.553-1.944L9 2m6 18l5.447-2.724A2 2 0 0021 15.488V5.512a2 2 0 00-1.553-1.944L15 2m-6 18V2m6 18V2" stroke-width="2"/></svg>
                                <p class="font-bold">No floor plans uploaded</p>
                            </div>
                        }  
                    }
        
                    @if (activeTab === 'video') {
                        @if (selectedPro?.propertyVideo?.length > 0) {
                            <div class="grid grid-cols-2 md:grid-cols-3 gap-4 animate-in fade-in slide-in-from-bottom-2">
                                @for (img of selectedPro?.propertyVideo; track img; let i = $index) {
                                    <div class="group relative aspect-square rounded-2xl overflow-hidden bg-gray-200 shadow-sm hover:shadow-xl transition-all duration-500">
                                        <img [src]="img" class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110">
                                        
                                        <div class="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            
                                            <div class="absolute top-2 right-2">
                                                <button 
                                                    (click)="$event.stopPropagation(); onDeleteImage(selectedPro?._id, img, 'video')"
                                                    class="p-2 bg-red-500 hover:bg-red-600 text-white rounded-full shadow-lg transform translate-y-2 group-hover:translate-y-0 transition-all duration-300"
                                                    title="Delete Image">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                    </svg>
                                                </button>
                                            </div>
                                
                                            <div class="absolute bottom-0 left-0 right-0 p-3">
                                                <span class="text-white text-[10px] font-bold uppercase tracking-wider block truncate">
                                                    {{ selectedPro?.name }} Img {{i+1}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        } @else {
                        <div class="flex flex-col items-center justify-center py-20 text-gray-400 animate-in fade-in">
                            <svg class="w-12 h-12 mb-2 opacity-20" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" stroke-width="2"/></svg>
                            <p class="font-bold">No videos available</p>
                        </div>
                    }
                    }
                </div>
        
                <div class="p-6 border-t border-gray-100 bg-white flex flex-col sm:flex-row gap-3">
                    <button (click)="closeModal()" class="flex-1 px-6 py-3 border border-gray-200 text-gray-700 font-bold rounded-xl hover:bg-gray-50 transition-all active:scale-95">
                        Cancel
                    </button>
                    <button (click)="navigateToGallery(selectedPro)" class="flex-1 px-6 py-3 bg-indigo-600 text-white font-bold rounded-xl hover:bg-indigo-700 shadow-lg shadow-indigo-100 transition-all flex items-center justify-center gap-2 active:scale-95">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M12 4v16m8-8H4" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        Manage Media
                    </button>
                </div>
            </div>
        </div>
        }
 <!-- <div *ngIf="showDeleteModal" 
     class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm transition-opacity duration-300">
    
    <div class="bg-white rounded-2xl p-6 w-full max-w-sm shadow-2xl transform transition-all duration-300 scale-100 animate-in zoom-in-95">
        
        <div class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
            <i class="fa fa-trash-alt text-red-600 text-xl"></i>
        </div>

        <div class="text-center mb-6">
            <h3 class="text-lg font-bold text-gray-900">Delete Property?</h3>
            <p class="text-sm text-gray-500 mt-2">
                This action cannot be undone. All data associated with this property will be permanently removed.
            </p>
        </div>

        <div class="flex gap-3">
            <button (click)="showDeleteModal = false" 
                    class="flex-1 px-4 py-2.5 bg-gray-100 text-gray-700 font-semibold rounded-xl hover:bg-gray-200 transition-colors">
                Cancel
            </button>
            <button (click)="deleteProperty()" 
                    class="flex-1 px-4 py-2.5 bg-red-600 text-white font-semibold rounded-xl hover:bg-red-700 transition-colors shadow-lg shadow-red-200">
                Delete
            </button>
        </div>
    </div>
</div> -->

<div *ngIf="showDeleteModal" 
     class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm transition-opacity duration-300">
    
    <div class="bg-white rounded-2xl p-6 w-full max-w-sm shadow-2xl transform transition-all duration-300 scale-100 animate-in zoom-in-95">
        
        <div class="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100 mb-4">
            <i class="fa fa-trash-alt text-red-600 text-xl"></i>
        </div>

        <div class="text-center mb-6">
            <h3 class="text-lg font-bold text-gray-900">Delete Property?</h3>
            <p class="text-sm text-gray-500 mt-2">
                This action cannot be undone. All data associated with this property will be permanently removed.
            </p>
        </div>

        <!-- Reason textarea -->
        <div class="mb-5">
            <label class="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1.5">
                Reason for Deletion <span class="text-red-500">*</span>
            </label>
            <textarea
                [(ngModel)]="deleteReason"
                rows="3"
                placeholder="e.g. Property sold, duplicate listing, incorrect data..."
                class="w-full px-4 py-3 text-sm text-gray-700 bg-gray-50 border border-gray-200 rounded-xl resize-none focus:outline-none focus:ring-4 focus:ring-red-500/10 focus:border-red-400 transition-all placeholder:text-gray-300">
            </textarea>
            <p *ngIf="deleteReasonError" class="mt-1 text-xs text-red-500 font-medium">
                Please provide a reason before deleting.
            </p>
        </div>

        <div class="flex gap-3">
            <button (click)="showDeleteModal = false; deleteReason = ''; deleteReasonError = false" 
                    class="flex-1 px-4 py-2.5 bg-gray-100 text-gray-700 font-semibold rounded-xl hover:bg-gray-200 transition-colors">
                Cancel
            </button>
            <button (click)="deleteProperty()" 
                    class="flex-1 px-4 py-2.5 bg-red-600 text-white font-semibold rounded-xl hover:bg-red-700 transition-colors shadow-lg shadow-red-200">
                Delete
            </button>
        </div>
    </div>
</div>
